import * as React from 'react';
import { Dispatch } from 'react-redux';
import { FormField } from '../typings';
import { StoreState } from '../../../../reducers';
import { SharePanelActionKeys } from '../../../../containers/Share/actions';
import { FormFieldContainer, InputField, EmailText } from '../styles';
import { Translate, I18n } from 'react-redux-i18n';
import CrmAutocompleteChoices from '../../../../containers/Share/UprezForm/CrmAutocompleteChoices';
import { Api } from '../../../../typings/api';

interface UprezShareFormFieldProps {
	fieldName: FormField;
	fieldValue: string;
	crmContacts: Api.CrmContact[];
	isOpen: boolean;
	isHeader: boolean;
	dispatch: Dispatch<StoreState>;
}

interface UprezShareFormFieldState {
	hasFocus: boolean;
}

class UprezShareFormField extends React.Component<UprezShareFormFieldProps, UprezShareFormFieldState> {
	focusTimer: NodeJS.Timer;

	constructor(props: UprezShareFormFieldProps) {
		super(props);
		this.fillField = this.fillField.bind(this);

		this.state = {
			hasFocus: false
		};
	}

	componentDidUpdate(prevProps: UprezShareFormFieldProps) {
		const { dispatch, fieldName, isOpen } = this.props;
		const fieldIsMessage = fieldName === FormField.Message;

		if (fieldIsMessage && !prevProps.isOpen && isOpen) {
			dispatch(
				{
					type: SharePanelActionKeys.SET_FORM_FIELD,
					name: FormField.Message,
					value: `${I18n.t('share.email_greeting')}\r${I18n.t('share.email_body')}`
				}
			);
		}
	}

	handleFocus(hasFocus: boolean) {
		if (hasFocus) {
			clearTimeout(this.focusTimer);
			this.setHasFocus(true);
		} else {
			// a delay of 300ms is used because onblur uses onmousedown which make the choice element disappear before the onclick fire
			// we can't use onmousedown to select the choice or scrolling won't be possible on mobile
			// TODO: find a better way of closing the contact choices list
			// global.setTimeout() is used because of typescript compiler thinking setTimeout() returns a number
			this.focusTimer = global.setTimeout(() => {
				this.setHasFocus(false);
			}, 300);
		}
	}

	setHasFocus(hasFocus: boolean) {
		this.setState({
			hasFocus
		});
	}

	fillField(e: React.FormEvent<HTMLInputElement> | React.FormEvent<HTMLTextAreaElement>) {
		const { dispatch, fieldName } = this.props;
		dispatch(
			{
				type: SharePanelActionKeys.SET_FORM_FIELD,
				name: fieldName,
				value: e.currentTarget.value
			}
		);

	}

	render() {
		const { fieldValue, fieldName, isHeader, crmContacts } = this.props;
		const { hasFocus } = this.state;
		const fieldIsEmail = fieldName === FormField.Email;
		const fieldIsMessage = fieldName === FormField.Message;

		// We don't use type "email" for email fields as the "multiple" property doesn't work well with React
		// When a comma + space is typed to separate addresses, the cursor goes back to the start of the input
		// Browser side email validation doesn't work on IOS so we check for it during the share action
		return (
			<>
				<FormFieldContainer isHeader={isHeader} fieldIsMessage={fieldIsMessage}>
					{fieldIsMessage
						? <EmailText
							onChange={this.fillField}
							value={fieldValue}
						/>
						: <>
							<Translate value={`share.${fieldName}`} />:
							<InputField
								onChange={this.fillField}
								onFocus={() => this.handleFocus(true)}
								onBlur={() => this.handleFocus(false)}
								value={fieldValue}
								required={fieldIsEmail}
								type="text"
								autoCorrect="off"
								autoComplete="off"
								autoCapitalize="none"
							/>
							<CrmAutocompleteChoices
								hasFocus={hasFocus}
								fieldName={fieldName}
								crmContacts={crmContacts}
								fieldValue={fieldValue}
							/>
						</>
					}
				</FormFieldContainer>
			</>
		);
	}
}

export default UprezShareFormField;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/Field/index.tsx